if (!customElements.get('quick-add-modal')) {
    customElements.define(
      'quick-add-modal',
      class QuickAddModal extends ModalDialog {
        constructor() {
          super();
          this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
          
          this.addEventListener('product-info:loaded', ({ target }) => {
            target.addPreProcessCallback(this.preprocessHTML.bind(this));
          });
        }
  
        isMobile() {
          return window.matchMedia('(max-width: 991px)').matches;
        }
  
        loadPackData(productElement) {
          const productId =
            productElement.dataset.productId ||
            productElement.getAttribute('data-product-id');
  
          if (!productId) {
            window.packData = [];
            return;
          }
  
          let script = productElement.querySelector(
            `.pack-data[data-product-id="${productId}"]`
          );
  
          if (!script) {
            script = document.querySelector(
              `.pack-data[data-product-id="${productId}"]`
            );
          }
  
          if (!script) {
            window.packData = [];
            return;
          }
  
          try {
            window.packData = JSON.parse(script.textContent.trim());
          } catch (e) {
            console.error('Invalid pack-data JSON', e);
            window.packData = [];
          }
        }
  
        formatMoneySafe(cents) {
          if (window.theme && typeof window.theme.formatMoney === 'function') {
            return window.theme.formatMoney(cents);
          }
          
          if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
            return window.Shopify.formatMoney(cents);
          }
          
          return (cents / 100).toFixed(2);
        }
  
        getVariants(productElement) {
          const el = productElement.querySelector('.quick-add-variants');
          return el ? JSON.parse(el.textContent) : [];
        }
  
        /* ================= MOBILE HELPERS ================= */
  
        getMobileSelectedQty(productElement) {
          const container = productElement.querySelector('#fragrance-selectors-mobile');
          if (!container) return 0;
  
          return [...container.querySelectorAll('.qty-value')]
            .reduce((sum, el) => sum + Number(el.textContent || 0), 0);
        }
  
        toggleMobileAddToCart(productElement) {
          const pack =
            Number(productElement.querySelector('input[name="pack-size"]:checked')?.value) || 1;
        
          const btn = productElement.querySelector(
            '#multi-variant-form button[type="submit"]'
          );
          if (!btn) return;
        
          if (pack === 1) {
            btn.disabled = false;
            btn.removeAttribute('aria-disabled');
            btn.classList.remove('disabled');
            return;
          }
        
          const totalQty = this.getMobileSelectedQty(productElement);
          const enabled = totalQty === pack;
        
          btn.disabled = !enabled;
          btn.setAttribute('aria-disabled', String(!enabled));
          btn.classList.toggle('disabled', !enabled);
        }
  
        /* ================= MEDIA ================= */
  
        updateProductMedia(productElement, variantId) {
          if (!productElement || !variantId) return;
          
          const variants = this.getVariants(productElement);
          const variant = variants.find(v => String(v.id) === String(variantId));
          if (!variant) return;
  
          const image =
            variant.featured_image ||
            variant.featured_media?.preview_image;
  
          if (!image?.src) return;
  
          const img = productElement.querySelector('.product__media img');
          if (!img) return;
  
          img.src = image.src;
          img.srcset = image.srcset || '';
          img.sizes = image.sizes || img.sizes;
          img.alt = variant.title || img.alt;
          img.loading = 'eager';

          // ✅ UPDATE VARIANT NAME HERE
          this.updateVariantName(productElement, variantId);
        }
  
        /* ================= DESKTOP ================= */
   
        bindBundleAddToCart(productElement) {
          const form = productElement.querySelector('form#multi-variant-form');
          if (!form) return;
  
          form.addEventListener('submit', (e) => {
            e.preventDefault();
  
            const packSize =
                  Number(productElement.querySelector('input[name="pack-size"]:checked')?.value) || 1;
  
            const items = [];
            productElement.querySelectorAll('.fragrance-fieldset').forEach((fs) => {
                  const chosen = fs.querySelector('input:checked');
                  if (chosen) items.push({ id: Number(chosen.value), quantity: 1 });
            });
  
            if (items.length !== packSize) {
                  alert(`Please select ${packSize} fragrances`);
                  return;
            }
  
            fetch('/cart/add.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ items }),
            })
                  .then(() => {
                  // document.querySelector('cart-drawer')?.open();
                  this.hide();
                  document.dispatchEvent(new CustomEvent('cart:refresh'));
                  window.handleFloCartBtn();
                  })
                  .catch(console.error);
          });
        }
        /* ================= DESKTOP ================= */

        bindPackSelector(productElement) {
          const pack = productElement.querySelector('.pack-selector');
          if (!pack) return;

          pack.addEventListener('change', (e) => {
              if (e.target.name !== 'pack-size') return;

              const count = Number(e.target.value);
              
              if (this.isMobile()) {
                  this.renderMobileFragrances(productElement, count);
                  if (count > 1) this.bindMobileQty(productElement, count);
              } else {
                  this.renderFragranceSelectors(productElement, count);
              }
              
              this.updateBundlePrice(productElement);
              
              const latestFieldset = productElement.querySelector(
                  `.fragrance-fieldset[data-index="${count}"]`
              );

              if (!latestFieldset) return;

              const selectedRadio = latestFieldset.querySelector(
                  'input[type="radio"]:checked'
              );
              this.updateProductMedia(productElement, selectedRadio.value);
          });
        }

        renderFragranceSelectors(productElement, packCount) {
            const container = productElement.querySelector('#fragrance-selectors');
            if (!container) return;

            const variants = this.getVariants(productElement);
            container.innerHTML = '';

            for (let i = 1; i <= packCount; i++) {
                const fieldset = document.createElement('fieldset');
                fieldset.className = 'fragrance-fieldset';
                fieldset.dataset.index = i;
                fieldset.innerHTML = `<legend>Pack ${i}</legend>`;

                variants.forEach((variant, index) => {
                    const id = `fragrance-${i}-${index}`;
                    const checked = index === i - 1 || index === 0 ? 'checked' : '';

                    const imgSrc = variant.featured_image?.src ? `${variant.featured_image.src}&width=70`: '';

                    fieldset.innerHTML += `
                        <input type="radio" name="fragrance-${i}" value="${variant.id}" id="${id}" ${checked}>
                        <label for="${id}">
                            <span class="variant-option">
                                <img src="${imgSrc}" alt="${variant.title}">
                                <span class="variant-title">${variant.title}</span>
                            </span>
                        </label>
                    `;
                });

                container.appendChild(fieldset);
            }

            // Bind change events for ALL fragrance fieldsets
            this.bindFragranceChangeEvents(productElement);
            
            this.updateBundlePrice(productElement);
        }

        // NEW METHOD: Bind change events to all fragrance radio buttons
        bindFragranceChangeEvents(productElement) {
            const container = productElement.querySelector('#fragrance-selectors');
            if (!container) return;
            
            // Remove any existing event listeners first
            container.removeEventListener('change', this.handleFragranceChange);
            
            // Create a bound handler
            this.handleFragranceChange = (e) => {
                const input = e.target.closest('input[type="radio"]');
                if (!input) return;
                
                this.updateBundlePrice(productElement);
                this.updateProductMedia(productElement, input.value);
            };
            
            // Add new event listener
            container.addEventListener('change', this.handleFragranceChange);
        }

        updateBundlePrice(productElement) {
            const variants = this.getVariants(productElement);
            
            if (this.isMobile()) {
                this.updateMobileBundlePrice(productElement);
                return;
            }
            
            const container = productElement.querySelector('#fragrance-selectors');
            if (!container) return;

            let total = 0;
            let compare = 0;

            container.querySelectorAll('.fragrance-fieldset').forEach(fs => {
                const chosen = fs.querySelector('input:checked');
                if (!chosen) return;

                const v = variants.find(v => String(v.id) === chosen.value);
                if (!v) return;

                total += Number(v.price);
                compare += Number(v.compare_at_price || v.price);
            });

            const pack =
                Number(productElement.querySelector('input[name="pack-size"]:checked')?.value) || 1;

            const packInfo = (window.packData || []).find(p => p.count === pack);
            const discount = packInfo ? Number(packInfo.discount) : 0;
            const finalPrice = total - total * discount;

            const priceBox =
                productElement.querySelector('#bundle-price') ||
                productElement.querySelector('.price__container');

            if (!priceBox) return;

            const saleEl =
                priceBox.querySelector('.price-item--sale') ||
                priceBox.querySelector('.price-item--regular');

            const compareEl = priceBox.querySelector('.price-item--regular');
            const hint = productElement.querySelector('.pack-discount-hint');

            if (saleEl) saleEl.textContent = this.formatMoneySafe(finalPrice);

            if (compareEl) {
                if (discount > 0 && compare > finalPrice) {
                    compareEl.textContent = this.formatMoneySafe(compare);
                    compareEl.style.display = '';
                    compareEl.style.textDecoration = 'line-through';
                } else {
                    compareEl.style.display = 'none';
                }
            }

            if (hint) {
                hint.style.display = discount > 0 ? '' : 'none';
                hint.textContent = discount > 0 ? `${Math.round(discount * 100)}% OFF` : '';
            }
        }
    
        /* ================= MOBILE ================= */
  
        updateMobileBundlePrice(productElement) {
          const variants = this.getVariants(productElement);
          if (!variants.length) return;
  
          const priceBox =
            productElement.querySelector('#bundle-price') ||
            productElement.querySelector('.price__container');
  
          if (!priceBox) return;
  
          const pack =
            Number(productElement.querySelector('input[name="pack-size"]:checked')?.value) || 1;
  
          let total = 0;
          let compare = 0;
          let selectedQty = 0;
  
          if (pack === 1) {
            const selected = productElement.querySelector('input[name="mobile-fragrance"]:checked');
            if (selected) {
              const v = variants.find(v => String(v.id) === selected.value);
              if (v) {
                total = Number(v.price);
                compare = Number(v.compare_at_price || v.price);
              }
            }
          } else {
            productElement.querySelectorAll('.mobile-fragrance-card').forEach(card => {
              const qty = Number(card.querySelector('.qty-value').textContent || 0);
              if (!qty) return;
  
              const v = variants.find(v => String(v.id) === card.dataset.variantId);
              if (!v) return;
  
              selectedQty += qty;
              total += qty * Number(v.price);
              compare += qty * Number(v.compare_at_price || v.price);
            });
  
            if (selectedQty === 0) {
              const cheapestPrice = Math.min(...variants.map(v => Number(v.price)));
              total = pack * cheapestPrice;
              compare = pack * cheapestPrice;
            }
          }
  
          const packInfo = (window.packData || []).find(p => p.count === pack);
          const discount = packInfo ? Number(packInfo.discount) : 0;
          const finalPrice = total - total * discount;
  
          const saleEl =
            priceBox.querySelector('.price-item--sale') ||
            priceBox.querySelector('.price-item--regular');
  
          const compareEl = priceBox.querySelector('.price-item--regular');
          const hint = productElement.querySelector('.pack-discount-hint');
  
          if (saleEl) saleEl.textContent = this.formatMoneySafe(finalPrice);
  
          if (compareEl) {
            if (discount > 0 && compare > finalPrice) {
              compareEl.textContent = this.formatMoneySafe(compare);
              compareEl.style.display = '';
              compareEl.style.textDecoration = 'line-through';
            } else {
              compareEl.style.display = 'none';
            }
          }
  
          if (hint) {
            hint.style.display = discount > 0 ? '' : 'none';
            hint.textContent = discount > 0 ? `${Math.round(discount * 100)}% OFF` : '';
          }
        }
  
        renderMobileFragrances(productElement, packCount) {
          const variants = this.getVariants(productElement);
          const container = productElement.querySelector('#fragrance-selectors-mobile');
          if (!container || !variants.length) return;
  
          container.innerHTML = '';
          this.bindMobileCardClick(productElement);
          if (packCount === 1) {
            variants.forEach((variant, index) => {
              container.innerHTML += `
                <div class="mobile-fragrance-card" data-variant-id="${variant.id}">
                <div style="display:flex;align-items:center;">
                  <img src="${variant.featured_image?.src || ''}">
                  <span>${variant.title}</span>
                  </div>
                  <input type="radio" name="mobile-fragrance" value="${variant.id}" ${index === 0 ? 'checked' : ''}>
                </div>
              `;
            });
            return;
          }
  
          variants.forEach(variant => {
            container.innerHTML += `
              <div class="mobile-fragrance-card" data-variant-id="${variant.id}">
              <div style="display:flex;align-items:center;">
                <img src="${variant.featured_image?.src || ''}">
                <span>${variant.title}</span>
                </div>
                <div class="qty-box">
                  <button type="button" class="qty-btn minus">−</button>
                  <span class="qty-value">0</span>
                  <button type="button" class="qty-btn plus">+</button>
                </div>
              </div>
            `;
          });
        }
  
        bindMobileQty(productElement, packCount) {
          const container = productElement.querySelector('#fragrance-selectors-mobile');
          if (!container) return;
  
          container.onclick = (e) => {
            const btn = e.target.closest('.qty-btn');
            if (!btn) return;
  
            const card = btn.closest('.mobile-fragrance-card');
            const valueEl = card.querySelector('.qty-value');
            let value = Number(valueEl.textContent);
  
            const total = this.getMobileSelectedQty(productElement);
  
            if (btn.classList.contains('plus')) {
              if (total >= packCount) return;
              value++;
            } else {
              value = Math.max(0, value - 1);
            }
  
            valueEl.textContent = value;
  
            this.updateMobileBundlePrice(productElement);
            this.toggleMobileAddToCart(productElement);
            this.updateProductMedia(productElement, card.dataset.variantId);
            this.updateVariantName(productElement, card.dataset.variantId);
          };
        }
  
        initMobileBundle(productElement) {
          const packInputs = productElement.querySelectorAll('input[name="pack-size"]');
          const form = productElement.querySelector('#multi-variant-form');
          const container = productElement.querySelector('#fragrance-selectors-mobile');
  
          const render = (count) => {
            this.renderMobileFragrances(productElement, count);
            if (count > 1) this.bindMobileQty(productElement, count);
            this.updateMobileBundlePrice(productElement);
            this.toggleMobileAddToCart(productElement);
          };
  
          const initialPack =
            Number(productElement.querySelector('input[name="pack-size"]:checked')?.value) || 1;
  
          render(initialPack);
          this.toggleMobileAddToCart(productElement);
  
          container?.addEventListener('change', (e) => {
            if (e.target.name === 'mobile-fragrance') {
              this.updateMobileBundlePrice(productElement);
              this.toggleMobileAddToCart(productElement);
              this.updateProductMedia(productElement, e.target.value);
              this.updateVariantName(productElement, e.target.value);
            }
          });
  
          packInputs.forEach(p =>
            p.addEventListener('change', () => render(Number(p.value)))
          );
  
          form?.addEventListener('submit', e => {
            e.preventDefault();
  
            const pack =
              Number(productElement.querySelector('input[name="pack-size"]:checked')?.value) || 1;
  
            const items = [];
  
            if (pack === 1) {
              const selected = productElement.querySelector('input[name="mobile-fragrance"]:checked');
              if (selected) items.push({ id: Number(selected.value), quantity: 1 });
            } else {
              productElement.querySelectorAll('.mobile-fragrance-card').forEach(card => {
                const qty = Number(card.querySelector('.qty-value').textContent);
                if (qty) items.push({ id: Number(card.dataset.variantId), quantity: qty });
              });
  
              const total = items.reduce((s, i) => s + i.quantity, 0);
              if (total !== pack) {
                alert(`Please select exactly ${pack} fragrances`);
                return;
              }
            }
  
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items }),
            }).then(() => {
              //document.querySelector('cart-drawer')?.open();
              this.hide();
              document.dispatchEvent(new CustomEvent('cart:refresh'));
              window.handleFloCartBtn();
            });
          });
        }
  
        updateVariantName(productElement, variantId) {
          if (!productElement || !variantId) return;
        
          const variants = this.getVariants(productElement);
          const variant = variants.find(v => String(v.id) === String(variantId));
          if (!variant) return;
        
          const nameEl = productElement.querySelector('.variant-name');
          if (!nameEl) return;
        
          nameEl.textContent = variant.title;
        }

        bindMobileCardClick(productElement) {
          const container = productElement.querySelector('#fragrance-selectors-mobile');
          if (!container) return;
        
          container.addEventListener('click', (e) => {
            const card = e.target.closest('.mobile-fragrance-card');
            if (!card) return;
        
            const radio = card.querySelector('input[type="radio"]');
            if (!radio) return;
        
            // Select radio
            if (!radio.checked) {
              radio.checked = true;
              radio.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
        }
        
        
        /* ================= SHOW/HIDE METHODS ================= */
  
        show(opener) {
          opener.setAttribute('aria-disabled', true);
          opener.classList.add('loading');
          opener.querySelector('.loading__spinner').classList.remove('hidden');

          fetch(opener.getAttribute('data-product-url') || opener.dataset.productUrl)
              .then((response) => response.text())
              .then((responseText) => {
                  const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
                  const productElement = responseHTML.querySelector('product-info');

                  this.preprocessHTML(productElement);
                  
                  // Use HTMLUpdateUtility if available, otherwise innerHTML
                  if (typeof HTMLUpdateUtility !== 'undefined' && HTMLUpdateUtility.setInnerHTML) {
                      HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);
                  } else {
                      this.modalContent.innerHTML = productElement.outerHTML;
                  }

                  const liveProductElement = this.modalContent.querySelector('product-info');
                  this.loadPackData(liveProductElement);

                  // Set Pack of 2 as default only for Car Freshener on VIP collection
                  const productUrl = opener.getAttribute('data-product-url') || opener.dataset.productUrl || '';
                  if (productUrl.includes('car-freshener-copy') && productUrl.includes('vip-picks')) {
                      const packInputs = liveProductElement.querySelectorAll('input[name="pack-size"]');
                      const pack2Input = [...packInputs].find(i => i.value === '2');
                      if (pack2Input) {
                          packInputs.forEach(i => i.checked = false);
                          pack2Input.checked = true;
                      }
                  }

                  const initialPack =
                      Number(liveProductElement.querySelector('input[name="pack-size"]:checked')?.value) || 1;

                  if (this.isMobile()) {
                      this.initMobileBundle(liveProductElement);
                  } else {
                      this.renderFragranceSelectors(liveProductElement, initialPack);
                      this.bindPackSelector(liveProductElement);
                      this.bindBundleAddToCart(liveProductElement);
                      
                      // Update media for the initially selected variant
                      const firstSelected = liveProductElement.querySelector('.fragrance-fieldset input:checked');
                      if (firstSelected) {
                          this.updateProductMedia(liveProductElement, firstSelected.value);
                          this.updateVariantName(liveProductElement, firstSelected.value);
                      }
                  }

                  if (window.Shopify?.PaymentButton) Shopify.PaymentButton.init();
                  if (window.ProductModel) window.ProductModel.loadShopifyXR();

                  super.show(opener);
              })
              .finally(() => {
                  opener.removeAttribute('aria-disabled');
                  opener.classList.remove('loading');
                  opener.querySelector('.loading__spinner').classList.add('hidden');
              });
        }
  
        hide(preventFocus = false) {
          const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          if (cartNotification) cartNotification.setActiveElement(this.openedBy);
          this.modalContent.innerHTML = '';
  
          if (preventFocus) this.openedBy = null;
          super.hide();
        }
  
        /* ================= HTML PROCESSING ================= */
  
        preprocessHTML(productElement) {
          // Copy color classes to modal
          productElement.classList.forEach((classApplied) => {
              if (classApplied.startsWith('color-') || classApplied === 'gradient')
                  this.modalContent.classList.add(classApplied);
          });
          
          this.preventDuplicatedIDs(productElement);
          this.removeDOMElements(productElement);
          this.removeGalleryListSemantic(productElement);
          this.updateImageSizes(productElement);
          this.preventVariantURLSwitching(productElement);
          
          const initialPack =
              Number(productElement.querySelector('input[name="pack-size"]:checked')?.value) || 1;

          // Pre-render for initial display
          if (this.isMobile()) {
              this.renderMobileFragrances(productElement, initialPack);
          } else {
              this.renderFragranceSelectors(productElement, initialPack);
          }
          
          this.bindPackSelector(productElement);
          this.bindBundleAddToCart(productElement);
          
          // Update media for initially selected variant in preprocess
          if (!this.isMobile()) {
              const firstSelected = productElement.querySelector('.fragrance-fieldset input:checked');
              if (firstSelected) {
                  this.updateProductMedia(productElement, firstSelected.value);
              }
          }
        }
  
        preventVariantURLSwitching(productElement) {
          productElement.setAttribute('data-update-url', 'false');
        }
  
        removeDOMElements(productElement) {
          const pickupAvailability = productElement.querySelector('pickup-availability');
          if (pickupAvailability) pickupAvailability.remove();
  
          const productModal = productElement.querySelector('product-modal');
          if (productModal) productModal.remove();
  
          const modalDialog = productElement.querySelectorAll('modal-dialog');
          if (modalDialog) modalDialog.forEach((modal) => modal.remove());
        }
  
        preventDuplicatedIDs(productElement) {
          const sectionId = productElement.dataset.section;
  
          const oldId = sectionId;
          const newId = `quickadd-${sectionId}`;
          productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
          Array.from(productElement.attributes).forEach((attribute) => {
            if (attribute.value.includes(oldId)) {
              productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
            }
          });
  
          productElement.dataset.originalSection = sectionId;
        }
  
        removeGalleryListSemantic(productElement) {
          const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
          if (!galleryList) return;
  
          galleryList.setAttribute('role', 'presentation');
          galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
        }
  
        updateImageSizes(productElement) {
          const product = productElement.querySelector('.product');
          const desktopColumns = product?.classList.contains('product--columns');
          if (!desktopColumns) return;
  
          const mediaImages = product.querySelectorAll('.product__media img');
          if (!mediaImages.length) return;
  
          let mediaImageSizes =
            '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';
  
          if (product.classList.contains('product--medium')) {
            mediaImageSizes = mediaImageSizes.replace('715px', '605px');
          } else if (product.classList.contains('product--small')) {
            mediaImageSizes = mediaImageSizes.replace('715px', '495px');
          }
  
          mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
        }
      }
    );
  }